import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { API_URL } from '../../../utils/ApiUrl';
import { formatDistanceToNow } from 'date-fns';
import { Dropdown } from 'react-bootstrap';
import { useWeb3React } from '@web3-react/core';
import { io } from 'socket.io-client';
import { useSocket } from '../../../contexts/SocketContext'; // import the hook
import { notificationType } from '../../../constants/notification';

function Notifications({ userData }) {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
   const navigate = useNavigate();
    let accessToken = localStorage.getItem('accessToken');
    const { account } = useWeb3React();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const socket = useSocket();
    
    const fetchNotifications = async (limit, beforeElement, afterElement) => {
        // console.log('adhfalsdjflasfdjl', 12334223);
        
        setNotifications([]);
        try {
            setLoading(true);

            const accessToken = localStorage.getItem('accessToken');
            if (!accessToken) {
                throw new Error('Access token not found');
            }

            const params = {
                limit, // Limit the number of results
                before: beforeElement, // Optional: element to fetch notifications before
                after: afterElement, // Optional: element to fetch notifications after
            };

            const response = await axios.get(`${API_URL}notifications`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`, // Pass the token in the Authorization header
                },
                params, // Query parameters
            });

            setNotifications(response.data.data); // Assuming the API returns data in the body
        } catch (err) {
            setError(err.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    const markAsReadAndNavigate = async (notificationId, taskId, link) => {
        
        
        try {
            const accessToken = localStorage.getItem('accessToken');
            if (!accessToken) {
                throw new Error('Access token not found');
            }
let payload;
            if (notificationId === 'markAllAsRead'){
                payload ={
                    markAllAsRead: true,}
            } else{
                payload = { id: notificationId }
            }
            // PATCH request to mark the notification as read
            await axios.patch(
                `${API_URL}notifications`, // Assuming PATCH endpoint for marking as read
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
fetchNotifications(10, null, null);
            // Once the notification is marked as read, navigate to the relevant page
            notificationId !== 'markAllAsRead' &&  (link ? navigate(`/${link}`) :  navigate(`/similartaskdetail/${taskId}`));
            notificationId !== 'markAllAsRead' &&  setDropdownOpen(false);
        } catch (err) {
            setError(err.message || 'Failed to mark notification as read');
        }
    };
    // const getSocket = async (val) => {
     
    //     const socket = io(API_URL, {
    //         transports: ["websocket", "polling"],
    //         auth: {
    //             Authorization: `Bearer ${val}`,
    //         },
    //     });


    //     socket.on('disconnect', () => {
    //         console.log('disconnected to the server');
    //     });


    //     socket.on('connect', () => {
    //         console.log('Connected to the server');
    //         localStorage.setItem('socketConnected', 'true');  // Set socket connected status in localStorage
    //     });

    //     socket.on('NOTIFICATION_ALERT', (event) => {
    //         console.log('Socket connected in neww', event);
    //         // setNotifications((prevNotifications) => [event, ...prevNotifications]);
    //         fetchNotifications(10, null, null);

    //     });
    //     socket.on('error', (error) => {
    //         console.error('Connection error: ', error.message); // Handle connection errors
    //     });
        
    //     // Store the socket instance in localStorage, if necessary.
    //     // This can be useful to manually disconnect the socket when needed.
    //     localStorage.setItem('socketInstance', JSON.stringify(socket));
    // }

    // useEffect(() => {
    //     if (accessToken) {
    //         getSocket(accessToken);
    //     }
    // }, [accessToken]);
    useEffect(() => {
        if (socket) {
            // Handle the 'NOTIFICATION_ALERT' event here
            socket.on('NOTIFICATION_ALERT', (event) => {
                console.log('New notification event in Navbar11:', event);
                fetchNotifications(10, null, null);
            });
        }

      
    }, [socket]);
    useEffect(() => {
        if (accessToken) {
        // Fetch initial notifications when the component mounts
        fetchNotifications(10, null, null); // Example: Fetch first 10 notifications
        }
    }, [accessToken]);

  return (
      <Dropdown align={'end'} className="notificationmainbtn" show={dropdownOpen} onToggle={() => setDropdownOpen(prev => !prev)}>
          <Dropdown.Toggle id="dropdown-basic">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <path d="M19.0609 15.1198C18.584 14.2983 17.875 11.9737 17.875 8.9375C17.875 7.11414 17.1507 5.36545 15.8614 4.07614C14.5721 2.78683 12.8234 2.0625 11 2.0625C9.17665 2.0625 7.42797 2.78683 6.13865 4.07614C4.84934 5.36545 4.12501 7.11414 4.12501 8.9375C4.12501 11.9745 3.41517 14.2983 2.93821 15.1198C2.81642 15.3287 2.75185 15.566 2.75102 15.8078C2.75019 16.0496 2.81312 16.2873 2.93349 16.497C3.05385 16.7067 3.22738 16.8809 3.43657 17.0022C3.64576 17.1234 3.88323 17.1873 4.12501 17.1875H7.63212C7.79074 17.9636 8.21256 18.6612 8.82625 19.1622C9.43994 19.6631 10.2078 19.9367 11 19.9367C11.7922 19.9367 12.5601 19.6631 13.1738 19.1622C13.7875 18.6612 14.2093 17.9636 14.3679 17.1875H17.875C18.1167 17.1872 18.3541 17.1231 18.5632 17.0018C18.7722 16.8805 18.9456 16.7063 19.0659 16.4966C19.1862 16.2869 19.249 16.0493 19.2481 15.8076C19.2473 15.5659 19.1827 15.3286 19.0609 15.1198ZM11 18.5625C10.5736 18.5624 10.1577 18.4301 9.8096 18.1838C9.46148 17.9376 9.19824 17.5895 9.05611 17.1875H12.9439C12.8018 17.5895 12.5385 17.9376 12.1904 18.1838C11.8423 18.4301 11.4264 18.5624 11 18.5625ZM4.12501 15.8125C4.78673 14.6747 5.50001 12.0381 5.50001 8.9375C5.50001 7.47881 6.07947 6.07986 7.11092 5.04841C8.14237 4.01696 9.54132 3.4375 11 3.4375C12.4587 3.4375 13.8576 4.01696 14.8891 5.04841C15.9205 6.07986 16.5 7.47881 16.5 8.9375C16.5 12.0355 17.2116 14.6721 17.875 15.8125H4.12501Z" fill="#013159" />
                  {notifications?.some(notification => !notification.isRead) &&  <circle cx="18" cy="4" r="4" fill="#FE0000" />}
              </svg>
          </Dropdown.Toggle>

          <Dropdown.Menu>
              <div className="notficationdrop">
                  <div className="notficationupper">
                      <h6 className="upperhead">Notifications</h6>
                   <div className='mainparentheading'>
                   { notifications?.some(notification => !notification.isRead) &&  <p onClick={() => markAsReadAndNavigate ('markAllAsRead',null, null)} className="markpara cp">Mark all as read</p>}
                          <Link onClick={() => setDropdownOpen(prev => !prev)} to='/notificationpreferences'><img src='\assets\notificationpic.png' alt='img' className='img-fluid' /></Link> 
                   </div>
                  </div>
                  {notifications?.length > 0 && <div className="notificationsmain">
                      {notifications?.map((notification, id) => {
                          const createdAt = notification?.createdAt ? new Date(notification.createdAt) : null;

                          let timeAgo = 'Invalid date';
                          if (createdAt && !isNaN(createdAt)) {
                              timeAgo = formatDistanceToNow(createdAt, { addSuffix: true });
                          }

                          return (
                              <div
                                  className={notification?.isRead ? 'innernotification' : 'innernotification active'}
                                  key={id}
                              >
                                  <span className="notificationimg">
                                      {notificationType[notification?.type]?.svg}
                                  </span>
                                  <div className="notificationtexts">
                                      <h6 className="notificationhead">{notification?.title}</h6>
                                      <p className="notificationpara">{notification?.message}</p>
                                      <div className="timemain">
                                          {!notification?.isRead && <span className="yellowcircle"></span>}
                                          <p className="timemainpara">{timeAgo}</p>
                                      </div>
                                      <div className="noticiationbtns">
                                          {notificationType[notification?.type]?.buttons?.map((btn, index) => {
                                              let link = btn?.link === 'tasksdetails' ? `tasksdetails/${notification?.taskId}` : btn?.link
                                          return(
                                             <button
                                                  key={index}
                                                  onClick={() =>
                                                      markAsReadAndNavigate(notification?.id, notification?.taskId, link)
                                                  }
                                                  className={btn?.class}
                                              >
                                                  {btn?.text}
                                              </button>
                                          )
                                             
                      })}
                                      </div>
                                  </div>
                              </div>
                          );
                      })}
                      
                  </div>}
              
                  {notifications?.length > 0 && <Link onClick={()=>setDropdownOpen(prev => !prev)} to="/allnotification" className="notficationlower">
                      <h6 className="lowerhead">See All Notifications</h6>
                  </Link>}
              </div>
          </Dropdown.Menu>
      </Dropdown>


  )
}

export default Notifications